export default __webpack_public_path__ + "static/media/Group 6136@2x.dd65b3e1.png";